module.exports = __webpack_public_path__ + "static/img/home_banner2.0bc02e54.png";